import { render, staticRenderFns } from "./ConsultorioCall.vue?vue&type=template&id=07a17c01&scoped=true"
import script from "./ConsultorioCall.vue?vue&type=script&lang=js"
export * from "./ConsultorioCall.vue?vue&type=script&lang=js"
import style0 from "./ConsultorioCall.vue?vue&type=style&index=0&id=07a17c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a17c01",
  null
  
)

export default component.exports